<template>
	<div class="message-detail">
		<van-row v-if="info">
			<van-col span="24" class="time">{{info.begin_time}}</van-col>
			<van-col span="24">
				<div class="con">
			  		<p class="title">{{info.name}}</p>
					<img :src="info.images" @error="nofind()"/>
			  		<div class="describe" v-html="info.describe"></div>
		  		</div>
			</van-col>
		</van-row>
	</div>
</template>

<script>
import defaultImg from '@/assets/common/ListPreload.png';
export default {
  data() {
    return {
    	info: {}
     
    };
  },
  created(){
	this.$api.setToken(this.$route.query.token)
　　	this.getRouterData()
  },
  methods: {
   	getRouterData() {
	    var ID = this.$route.query.id
		this.$api.post("/activity/index/ad/get-data", {label: 'message_shull_buy_activity'}).then(res => {
	        for(var i in res.adData){
	        	if(res.adData[i].ad_id == ID){
	        		this.info = res.adData[i];
	        	}
	        }
	    });
    },
  	nofind() {
	    var img = event.srcElement;
		img.src = defaultImg;
		img.onerror = null; //防止闪图
	}
  }
};
</script>

<style lang="less">
.message-detail {
	background: #f2f2f2;
	min-height: 100%;
	.van-col {
		padding: 0 12px;
		.con {
			background: #fff;
			padding: 0 12px 30px;
			border-radius: 10px;
			.title {
				color: #333;
				font-size: 13px;
				// height: 42px;
				line-height: 42px;
				font-weight: 700;
			}
			img {
				width: 100%;
				min-height: 120px;
				display: block;
				background: #f5f5f5;
			}
			.describe {
				color: #666;
				font-size: 12px;
				line-height: 18px;
				padding-top: 12px;
			}
		}
	}
	.time {
		font-size: 11px !important;
		color: #999;
		text-align: center;
		height: 40px;
		line-height: 40px;
	}
}



</style>
